import React, { useState } from 'react';
import { Smartphone, Globe, Bot, ShieldCheck, Cloud, BarChart2, Settings, Palette, Database, GraduationCap, Timer, TrendingUp } from 'lucide-react';
import useResponsive from '../hooks/useResponsive';

const COURSES = [
  { icon: Smartphone, iconColor:'#f97316', title:'Mobile App Development', sub:'Android & iOS', dur:'6 Months', lvl:'Beginner to Pro', price:'₹25,000', badge:'Most Popular', bc:'#f97316', border:'rgba(249,115,22,0.3)', bg:'rgba(249,115,22,0.07)', tags:['React Native','Flutter','Firebase','REST APIs'], cat:'mobile' },
  { icon: Globe,      iconColor:'#3b82f6', title:'Full Stack Development', sub:'MERN / MEAN Stack', dur:'8 Months', lvl:'Beginner to Pro', price:'₹30,000', badge:'Best Value', bc:'#3b82f6', border:'rgba(59,130,246,0.3)', bg:'rgba(59,130,246,0.07)', tags:['React.js','Node.js','MongoDB','AWS'], cat:'web' },
  { icon: Bot,        iconColor:'#a855f7', title:'AI / Machine Learning', sub:'Python & Deep Learning', dur:'6 Months', lvl:'Intermediate', price:'₹35,000', badge:'Trending', bc:'#a855f7', border:'rgba(168,85,247,0.3)', bg:'rgba(168,85,247,0.07)', tags:['TensorFlow','NLP','OpenCV','Scikit-Learn'], cat:'ai' },
  { icon: ShieldCheck,iconColor:'#ef4444', title:'Cybersecurity', sub:'Ethical Hacking & SOC', dur:'5 Months', lvl:'Beginner to Pro', price:'₹28,000', badge:'In Demand', bc:'#ef4444', border:'rgba(239,68,68,0.3)', bg:'rgba(239,68,68,0.07)', tags:['Ethical Hacking','Pen Testing','CEH','OWASP'], cat:'security' },
  { icon: Cloud,      iconColor:'#14b8a6', title:'Cloud Computing', sub:'AWS / Azure / GCP', dur:'4 Months', lvl:'Intermediate', price:'₹22,000', badge:'', bc:'', border:'rgba(20,184,166,0.3)', bg:'rgba(20,184,166,0.07)', tags:['AWS','Docker','Kubernetes','CI/CD'], cat:'cloud' },
  { icon: BarChart2,  iconColor:'#22c55e', title:'Data Science', sub:'Analytics & Visualization', dur:'5 Months', lvl:'Beginner to Pro', price:'₹27,000', badge:'', bc:'', border:'rgba(34,197,94,0.3)', bg:'rgba(34,197,94,0.07)', tags:['Python','Power BI','Tableau','SQL'], cat:'data' },
  { icon: Settings,   iconColor:'#eab308', title:'DevOps Engineering', sub:'CI/CD & Automation', dur:'4 Months', lvl:'Intermediate', price:'₹24,000', badge:'', bc:'', border:'rgba(234,179,8,0.3)', bg:'rgba(234,179,8,0.07)', tags:['Linux','Jenkins','Docker','Terraform'], cat:'cloud' },
  { icon: Palette,    iconColor:'#ec4899', title:'UI/UX Design', sub:'Figma & Design Systems', dur:'3 Months', lvl:'Beginner', price:'₹18,000', badge:'', bc:'', border:'rgba(236,72,153,0.3)', bg:'rgba(236,72,153,0.07)', tags:['Figma','Wireframing','Prototyping','Research'], cat:'design' },
  { icon: Database,   iconColor:'#6366f1', title:'Database & SQL', sub:'MySQL, PostgreSQL, MongoDB', dur:'2 Months', lvl:'Beginner', price:'₹12,000', badge:'', bc:'', border:'rgba(99,102,241,0.3)', bg:'rgba(99,102,241,0.07)', tags:['SQL','Advanced Queries','MongoDB','PostgreSQL'], cat:'data' },
];

const FILTERS = [
  { label:'All', cat:'all' }, { label:'Mobile', cat:'mobile' },
  { label:'Web', cat:'web' }, { label:'AI / ML', cat:'ai' },
  { label:'Security', cat:'security' }, { label:'Cloud', cat:'cloud' },
  { label:'Data', cat:'data' }, { label:'Design', cat:'design' },
];

export default function Courses({ scrollTo }) {
  const [active, setActive] = useState('all');
  const { isMobile, isTablet } = useResponsive();
  const list = active === 'all' ? COURSES : COURSES.filter(c => c.cat === active);

  const paddingH = isMobile ? 16 : isTablet ? 24 : 40;
  const cols = isMobile ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(3,1fr)';

  return (
    <div style={{ padding: `80px ${paddingH}px`, minHeight:'100vh', paddingTop:'80px' }}>

      {/* Heading */}
      <div style={{ textAlign:'center', marginBottom:44 }}>
        <div style={{ display:'inline-flex', alignItems:'center', gap:7, padding:'6px 16px', borderRadius:99, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', fontSize:12, fontWeight:600, color:'#fb923c', marginBottom:14 }}>
          <GraduationCap size={14} strokeWidth={2.5} color="#fb923c" />
          Our Curriculum
        </div>
        <h2 style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?28:isTablet?36:42, fontWeight:800, color:'#fff', letterSpacing:-1, marginBottom:10 }}>
          Industry-Ready{' '}
          <span style={{ background:'linear-gradient(135deg,#38bdf8,#f97316,#c084fc)', backgroundSize:'300%', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', animation:'gx 5s ease infinite' }}>Courses</span>
        </h2>
        <p style={{ fontSize: isMobile?13:15, color:'#475569' }}>Har course real-world projects, live mentorship, aur placement support ke saath aata hai.</p>
      </div>

      {/* Filters */}
      <div style={{ display:'flex', justifyContent:'center', gap: isMobile?6:8, flexWrap:'wrap', marginBottom:36 }}>
        {FILTERS.map(f => (
          <button key={f.cat} onClick={() => setActive(f.cat)} style={{
            padding: isMobile?'7px 14px':'9px 20px', borderRadius:99,
            fontFamily:"'DM Sans',sans-serif", fontSize: isMobile?11:12, fontWeight:600, cursor:'pointer', border:'none',
            background: active===f.cat ? '#2563eb' : 'rgba(255,255,255,0.04)',
            color: active===f.cat ? '#fff' : '#64748b',
            boxShadow: active===f.cat ? '0 4px 14px rgba(37,99,235,0.3)' : 'none',
            outline: active!==f.cat ? '1px solid rgba(255,255,255,0.07)' : 'none',
            transition:'all 0.2s',
          }}>{f.label}</button>
        ))}
      </div>

      {/* Cards Grid */}
      <div style={{ display:'grid', gridTemplateColumns: cols, gap: isMobile?16:20, maxWidth:1200, margin:'0 auto' }}>
        {list.map(c => {
          const Icon = c.icon;
          return (
            <div key={c.title} style={{ borderRadius:22, padding: isMobile?18:24, position:'relative', overflow:'hidden', background:c.bg, border:`1px solid ${c.border}`, transition:'all 0.3s', cursor:'default' }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-7px)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform='none'; }}>

              {c.badge && <span style={{ position:'absolute', top:14, right:14, background:c.bc, color:'#fff', fontSize:10, fontWeight:700, padding:'4px 10px', borderRadius:99 }}>{c.badge}</span>}

              {/* Course Icon */}
              <div style={{ width: isMobile?44:52, height: isMobile?44:52, borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', background:`${c.iconColor}18`, border:`1px solid ${c.iconColor}30`, marginBottom:16 }}>
                <Icon size={isMobile?22:26} color={c.iconColor} strokeWidth={1.8} />
              </div>

              <div style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?16:18, fontWeight:700, color:'#fff', marginBottom:4, letterSpacing:-0.3 }}>{c.title}</div>
              <div style={{ fontSize:12, color:'#64748b', marginBottom:14 }}>{c.sub}</div>

              {/* Duration & Level badges */}
              <div style={{ display:'flex', gap:7, marginBottom:14, flexWrap:'wrap' }}>
                <span style={{ display:'flex', alignItems:'center', gap:4, padding:'4px 11px', borderRadius:99, fontSize:11, fontWeight:500, color:'#60a5fa', background:'rgba(59,130,246,0.1)' }}>
                  <Timer size={11} strokeWidth={2} /> {c.dur}
                </span>
                <span style={{ display:'flex', alignItems:'center', gap:4, padding:'4px 11px', borderRadius:99, fontSize:11, fontWeight:500, color:'#4ade80', background:'rgba(74,222,128,0.1)' }}>
                  <TrendingUp size={11} strokeWidth={2} /> {c.lvl}
                </span>
              </div>

              {/* Tags */}
              <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:18 }}>
                {c.tags.map(t => <span key={t} style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', color:'#94a3b8', fontSize:11, padding:'3px 9px', borderRadius:6 }}>{t}</span>)}
              </div>

              {/* Price & Enroll */}
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:14, borderTop:'1px solid rgba(255,255,255,0.08)' }}>
                <div style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?18:22, fontWeight:800, color:'#fff', letterSpacing:-0.5 }}>
                  {c.price} <span style={{ fontSize:11, color:'#334155', fontWeight:400 }}>/ course</span>
                </div>
                <button onClick={() => scrollTo('contact')} style={{ background:'linear-gradient(135deg,#2563eb,#1d4ed8)', border:'none', padding:'9px 18px', borderRadius:10, color:'#fff', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  Enroll →
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}